import React from 'react';
import {
  Avatar,
  AvatarBadge,
  Flex,
  Heading,
  Icon,
  Text,
  Tooltip,
  Wrap,
  WrapItem,
} from '@chakra-ui/core';
import { CgCrown } from 'react-icons/cg';
import { User } from '../types';

interface ParticipantListProps {
  users: User[];
}

const ParticipantList = ({ users }: ParticipantListProps) => (
  <>
    <Heading fontSize="md" mb={4}>{`Participants (${users.length})`}</Heading>
    <Wrap direction="row" spacing={5}>
      {users.map(avatarUser => (
        <WrapItem key={avatarUser.id}>
          <Flex direction="column" align="center">
            <Tooltip
              hasArrow
              label={`${avatarUser.metadata.nickname}${
                avatarUser.metadata.mod.enabled ? ' (mod)' : ''
              }`}
              openDelay={500}>
              <Avatar size="md" name={avatarUser.metadata.nickname}>
                {avatarUser.metadata.mod.enabled &&
                avatarUser.metadata.mod.allowVote &&
                (avatarUser.metadata.hasVoted || avatarUser.metadata.vote) ? (
                  <AvatarBadge boxSize="1.25em" bg="green.500">
                    <Icon as={CgCrown} boxSize="0.7em" />
                  </AvatarBadge>
                ) : avatarUser.metadata.mod.enabled ? (
                  <AvatarBadge boxSize="1.25em" bg="purple.400">
                    <Icon as={CgCrown} boxSize="0.7em" />
                  </AvatarBadge>
                ) : avatarUser.metadata.hasVoted || avatarUser.metadata.vote ? (
                  <AvatarBadge bg="green.400" boxSize="1.25em" />
                ) : null}
              </Avatar>
            </Tooltip>
            <Text fontSize="xs" mt={1} maxW="16" isTruncated>
              {avatarUser.metadata.nickname}
            </Text>
          </Flex>
        </WrapItem>
      ))}
    </Wrap>
  </>
);

export default ParticipantList;
